import {
	apiPost,
	apiPut,
	apiDelete
} from './api';

//查询优惠卷
export const couponList = (data) => {
	return apiPost('/ecommerce/coupon/query', data);
};
//新增优惠卷
export const createCoupon = (data) => {
	return apiPost('/ecommerce/coupon/create', data);
};
// 删除商品
export const removeCoupon = (data) => {
	const {
		ids = []
	} = data;
	console.log("优惠卷接口js", ids)
	const queryParams = ids.map(id => `ids=${id}`).join('&');
	const url = `/ecommerce/coupon/remove?${queryParams}`;
	return apiDelete(url);
};

// 查询店铺活动用户中奖信息
export const queryActivityPrizeUser = (data) => {
	return apiPost('/ecommerce/coupon/activityPrizeUser/query', data);
};

// 核销使用用户奖品
export const verifyAndUsePrize = (prizeCode) => {
	return apiPut(`/ecommerce/coupon/activityPrizeUser/verifyAndUse?prizeCode=${encodeURIComponent(prizeCode)}`);
};
